import { jwtDecode } from "jwt-decode";

class StorageService {
  constructor() {
    this.tokenKey = "eparoxos-token";
    this.userKey = "eparoxos-user";
    this.userEmailKey = "eparoxos-login-email";
  }

  setData(data) {
    localStorage.setItem(this.tokenKey, data);
    const tokenData = jwtDecode(data);
    localStorage.setItem(this.userKey, JSON.stringify(tokenData));
  }

  getToken() {
    return localStorage.getItem(this.tokenKey);
  }

  getUser() {
    const data = localStorage.getItem(this.userKey);
    if (!data) return null;
    const parsedData = JSON.parse(data);
    return parsedData.user;
  }

  getAccessLevel() {
    const user = this.getUser();
    if (!user) return -1;
    return user.role.accessLevel;
  }

  deleteData() {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
  }

  setUserEmail(data) {
    localStorage.setItem(this.userEmailKey, data);
  }

  getUserEmail() {
    return localStorage.getItem(this.userEmailKey);
  }

  deleteUserEmail() {
    localStorage.removeItem(this.userEmailKey);
  }
}

export default new StorageService();
